import { render, staticRenderFns } from "./courceList.vue?vue&type=template&id=8dbfc260"
import script from "./courceList.vue?vue&type=script&lang=js"
export * from "./courceList.vue?vue&type=script&lang=js"
import style0 from "./courceList.vue?vue&type=style&index=0&id=8dbfc260&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports